export default __webpack_public_path__ + "static/media/redlap.a6a87f44.jpg";